import React from "react";

export const Paw = ({ className = "", style }) => (
  <svg viewBox="0 0 64 64" className={className} style={style} fill="currentColor" aria-hidden="true">
    <ellipse cx="20" cy="20" rx="7" ry="9" />
    <ellipse cx="44" cy="20" rx="7" ry="9" />
    <ellipse cx="10" cy="38" rx="6" ry="8" />
    <ellipse cx="54" cy="38" rx="6" ry="8" />
    <path d="M32 30c-9 0-17 7-17 15 0 6 5 9 10 7 4-1.6 10-1.6 14 0 5 2 10-1 10-7 0-8-8-15-17-15z" />
  </svg>
);

export const Bone = ({ className = "", style }) => (
  <svg viewBox="0 0 100 44" className={className} style={style} fill="currentColor" aria-hidden="true">
    <path d="M22 22c0-7-5-12-12-12S-2 15 4 20c-5 3-4 14 6 14 7 0 12-5 12-12zm56 0c0 7 5 12 12 12s12-5 6-14c5-3 4-14-6-14-7 0-12 5-12 12z" />
    <rect x="18" y="15" width="64" height="14" rx="7" />
  </svg>
);

export const Star = ({ className = "", style }) => (
  <svg viewBox="0 0 24 24" className={className} style={style} fill="currentColor" aria-hidden="true">
    <path d="M12 2l2.4 6.3L21 9l-5 4.3L17.6 20 12 16.3 6.4 20 8 13.3 3 9l6.6-.7z" />
  </svg>
);

export const Blob = ({ className = "", style }) => (
  <svg viewBox="0 0 200 200" className={className} style={style} fill="currentColor" aria-hidden="true">
    <path d="M42.7,-64.3C55.9,-56.8,67.4,-45.9,72.9,-32.4C78.4,-18.9,77.9,-2.9,73.3,11.2C68.7,25.3,60.1,37.6,48.9,47.6C37.7,57.6,24,65.3,8.6,70.5C-6.7,75.6,-23.7,78.2,-37.7,72.3C-51.7,66.4,-62.6,52,-69.2,36.2C-75.8,20.4,-78,3.2,-74.6,-12.7C-71.2,-28.6,-62.1,-43.1,-49.6,-51C-37.1,-58.9,-21.2,-60.2,-4.9,-53.5C11.4,-46.8,22.8,-32.1,42.7,-64.3Z" transform="translate(100 100)" />
  </svg>
);

// Curved divider that sits at the bottom of a section, filling with `color`.
export const WaveDivider = ({ color = "#FFFFFF", flip = false, className = "" }) => (
  <div className={`w-full leading-[0] ${className}`} style={flip ? { transform: "scaleY(-1)" } : undefined} aria-hidden="true">
    <svg viewBox="0 0 1440 90" preserveAspectRatio="none" className="w-full h-[48px] sm:h-[70px] block">
      <path d="M0,32 C240,90 480,90 720,58 C960,26 1200,26 1440,58 L1440,90 L0,90 Z" fill={color} />
    </svg>
  </div>
);

// Faint tiled paw-print background layer.
export const PawField = ({ className = "", color = "#19324A", opacity = 0.06 }) => (
  <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true" style={{ opacity }}>
    {[...Array(10)].map((_, i) => (
      <Paw key={i} className="absolute" style={{
        color, width: 40 + (i % 3) * 22,
        top: `${(i * 37) % 95}%`, left: `${(i * 53) % 92}%`,
        transform: `rotate(${(i * 47) % 360}deg)`,
      }} />
    ))}
  </div>
);
